import { Slot } from "@radix-ui/react-slot";
import type { ButtonHTMLAttributes } from "react";

const VARIANTS = {
  primary: "bg-[var(--color-primary)] text-[var(--color-on-primary)] hover:opacity-90",
  secondary: "border border-[var(--color-border)] hover:bg-[var(--color-surface)]",
  ghost: "hover:bg-[var(--color-surface)]",
} as const;

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: keyof typeof VARIANTS;
  /** Render the child (a link) with the button's look. */
  asChild?: boolean;
}

export function Button({ variant = "primary", asChild, className = "", type, ...props }: ButtonProps) {
  const Component = asChild ? Slot : "button";
  return (
    <Component
      type={asChild ? undefined : (type ?? "button")}
      className={`inline-flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium disabled:cursor-not-allowed disabled:opacity-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--color-primary)] ${VARIANTS[variant]} ${className}`}
      {...props}
    />
  );
}
